module.exports = __webpack_public_path__ + "img/business.adc6822e.svg";